import React from "react";
import { Container, Col, Row } from "react-bootstrap";
import Accordion from "react-bootstrap/Accordion";
// import "./../../Products/Faq/Faq.css";
import AskFaq from "./../../../../Images/askFaq.png";
function CommoditiesFAQ() {
  return (
    <>
      <section className="faq-block">
        <Container>
          <Row>
            <Col md={8}>
              <h1>Frequently Asked Questions</h1>
              <Accordion defaultActiveKey="0">
                <Accordion.Item eventKey="0">
                  <Accordion.Header>
                    Q1. What is a commodity market?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>
                      A commodity market is one that deals in trading raw
                      materials or primary products rather than manufacturing
                      products, such as cocoa, fruit, and sugar. Commodity
                      pricing is primarily influenced by economic development
                      and technological advances, supply, demand, and scarcity.
                      Commodities can be a promising way for investors to
                      diversify their portfolios beyond traditional securities.
                      Because commodity prices tend to move in opposition to
                      stock prices, some investors rely on commodities during
                      periods of market volatility. Futures contracts are the
                      most traditional type of commodity investment. Commodity
                      markets can include physical trading as well as
                      derivatives trading using spot prices, forwards, and
                      futures.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="1">
                  <Accordion.Header>
                  Q2. Is it necessary for me to open a separate account for trading in commodity segment?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>No, you can trade in the commodities market using your regular trading account.</p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="2">
                  <Accordion.Header>
                  Q3. What are the charges associated with trading in the commodity market?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>
                    You can check the charges for trading in commodity segment from <a href="/Pricing" target="_blank">here</a>.
                    </p>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="3">
                  <Accordion.Header>
                  Q4. How can I trade in the commodity segment using Moneysukh?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <ul>
                      {/* <li>Visit trade.moneysukh.com and login through your Moneysukh User ID & password.</li> */}
                      <li>Visit <a href="https://online.moneysukh.com" target="_blank">https://online.moneysukh.com</a> and login with your Moneysukh User ID & password.</li>
                      <li>Search for the commodity contract you wish to trade.</li>
                      <li>You must ensure that you have sufficient funds to trade that commodity</li>
                      <li>Hover over the security and Tap on buy/sell. Fill in the necessary details like price, quantity, etc.</li>
                      <li>Conclude the transaction.</li> 
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
                <Accordion.Item eventKey="4">
                  <Accordion.Header>
                  Q5. What are the key elements influencing the movement of commodity prices in commodity derivatives trading?
                  </Accordion.Header>
                                  <Accordion.Body className="textjustify">
                    <p>The key elements influencing commodity price movement are demand and supply, currency fluctuations, news, macroeconomic circumstances, advancements, seasonality, and so on. The trading prices of most commodities are also impacted by global variables and may be connected to prices on international stock markets.</p>
                  </Accordion.Body>
                </Accordion.Item>
              </Accordion>
            </Col>
            <Col md={4}>
              <div className="faq-beta">
                <img className="img-fluid" src={AskFaq} alt={AskFaq} />
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default CommoditiesFAQ;
